module.exports = __webpack_public_path__ + "static/2-7ec1e5d881a3885fb067a1242326964e.png";